/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 */

import MarkdownHeader from './MarkdownHeader';

export default MarkdownHeader;
